export enum OwnershipConversionControlName {
  LawPerson = 'lawPerson',
  DecisionForm = 'decisionForm',
  ShippingForm = 'shippingForm',
  Comments = 'comments'
}
